import React, { Component } from 'react'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { joinLeague } from '../../actions/LeagueActions';
import common from '../../common';
import apiError from './../../constants/api-error';
import trackEventsObj from '../../constants/new-pageTrackEvents'


class LeagueInvite extends Component {
    constructor(props) {
        super(props);
        this.onDecline = this.onDecline.bind(this);
        this.onAccept = this.onAccept.bind(this);

        this.state = {

        }
    }



    onAccept() {
        const { leagueName, leagueCode } = this.props;
        const GUID = common.getGUID();
        common.showLoader();
        // common.customTracking('Join League');
        this.props.joinLeague(GUID, leagueCode).then(() => {
            common.hideLoader();
            const response = this.props.joinLeagueResponse;
            const retVal = response.Meta['RetVal'];
            const errorKeyFromTrans = apiError.joinLeague[retVal];
            let message = this.props.trans[errorKeyFromTrans];
            if (retVal == 9) {
                message += " <b>" + leagueName + "</b>"
            }
            if (response.Meta['Success'] && retVal === 1) {
                common.customTracking('Join League By Link', '/uclfantasy/leagues/');
                common.removeLocalStorage('shareLoad');
                common.removeLocalStorage('leagueInvObj');
                sessionStorage.setItem('joinTeamSuccess', true);
                return this.props.history.push('/league-leaderboard/' + response.Data.Value.LeagueId);
            } else {
                if (this.props.onError) {
                    this.props.onError(message, retVal)
                }
                // let stateToSet = {
                //     inlineMessage: message,
                // };
                // this.setState(stateToSet);
                // let stateToSet = {
                //     message,
                //     isToast: true,
                //     popupWrapperClass: 'si-warning-toast si-error-popup',
                //     iconClass: 'icon-ucl-warning-icon',
                //     showPopup: true
                // };
                // if(this.props.handleToast){
                //     this.props.handleToast(stateToSet);
                //     // this.onDecline()
                // }
            }
        });
    }

    onDecline() {
        if (this.props.onDecline) {
            this.props.onDecline()
        }
    }

    render() {
        const { trans, leagueName, userName } = this.props;
        return (
            <div className="si-modal-wrap">
                <div className="si-common-popup si-invite-popup">
                    <div className="si-popup-body si-flexBox">
                        <i className="si-close icon-ucl-close" onClick={ this.onDecline }></i>
                        <div className="si-logo-wrap">
                            <span><i className="icon-ucl-join"></i></span>
                        </div>
                        <div className="si-details-wrap">
                            <div className="si-more-info">
                                <span><b>{ userName }</b> { trans['invite_joinLeagueText'] || "has invited you to join the league" }  <b>{ leagueName }</b> </span>
                                <span>{ trans['invite_confirmJoinLeagueText'] || "Do you wish to join?" }</span>
                            </div>
                        </div>
                    </div>
                    <div className="si-popup-btn-wrap">
                        <div className="si-btn si-btn-secondary-wb" onClick={ this.onDecline }>
                            <span>{ trans["leagueInvite_decline"] || "No, decline" }</span>
                        </div>
                        <div className="si-btn si-btn-primary" onClick={ this.onAccept }>
                            <span>{ trans["leagueInvite_accept"] || "Yes, join" }</span>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        joinLeague: (GUID, leagueCode) => dispatch(joinLeague(GUID, leagueCode)),
    };
};
const mapStateToProps = (state) => {

    return {
        trans: state.appData.trans,
        joinLeagueResponse: state.leaguesData.joinLeagueResponse
    };
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LeagueInvite));


// WEBPACK FOOTER //
// ./src/components/leagues/leagueInvite.js